<template>
  <div>
    <AlignedUsers
      v-if="objective.alignedToUsers.length > 0"
      :can-edit="canEdit"
      :entity="{
        id: objective.id,
        type: 'objective',
        statementId: objective.statementId.id
      }"
      :aligned-users="objective.alignedToUsers"
      v-bind="$attrs"
    />
    <div
      class="objective-content"
      :class="{ 'has-alignment-down': objective.alignedFromUsers.length > 0 }"
    >
      <div
        :class="{ clickable: canEdit }"
        @click="$emit('click-objective')"
        v-html="'O' + (index + 1) + ': ' + objective.content"
      />
      <icon-font
        type="iconmubiao"
        class="objective-content__icon"
      />
      <ToBeAlignedDot
        v-if="!canEdit && isToBeAligned"
        class="to-be-aligned-dot"
      />
      <MenuOutlined
        v-if="canEdit"
        class="objective-drag-icon"
      />
      <AlignmentLine
        v-if="objective.alignedToUsers.length > 0"
        :up="true"
        class="objective-content__alignment-up"
      />
      <AlignmentLine
        v-if="objective.alignedFromUsers.length > 0"
        :up="false"
        class="objective-content__alignment-down"
      />
    </div>
    <AlignUserForPerformance
      v-if="objective.alignedFromUsers.length > 0"
      :entity="{
        id: objective.id,
        type: 'objective',
        statementId: objective.statementId.id
      }"
      :aligned-users="objective.alignedFromUsers"
      v-bind="$attrs"
    />
    <div v-if="objective.isFinancial">
      <a-popover>
        <template #content>
          <span>{{ $t('okr.list.financialTarget') }}</span>
        </template>
        <img
          src="@/assets/images/finance.png"
          class="financial-target-icon"
        >
      </a-popover>
    </div>
    <Performance
      v-if="!objective.performanceIsHide || isMyManagementScope"
      v-bind="$attrs"
      :performance-objective="
        JSON.parse(objective.performanceObjective || '{}')
      "
    />
  </div>
</template>

<script>
import { computed, toRefs, watch } from 'vue'
import { useStore } from 'vuex'
import { MenuOutlined } from '@ant-design/icons-vue'
import { editObjectiveAuth, removeObjectiveAuth } from '@/api/auth'
import useMention from '@/composables/use-mention'

import AlignedUsers from './AlignedUsers'
import AlignUserForPerformance from './AlignedUsersForPerformance/index.vue'
import AlignmentLine from './AlignmentLine'
import ToBeAlignedDot from '@/components/ToBeAlignedDot'
import Performance from './Performance'

export default {
  components: {
    MenuOutlined,
    AlignedUsers,
    AlignUserForPerformance,
    AlignmentLine,
    ToBeAlignedDot,
    Performance
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    objective: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isMyManagementScope: {
      type: Boolean,
      default: true
    }
  },
  emits: ['click-objective'],
  setup (props) {
    const { state } = useStore()
    const user = computed(() => state.user)
    const isToBeAligned = computed(
      () =>
        !props.canEdit &&
        props.objective.mentionUserIds.includes(user.value.uid) &&
        !props.objective.alignedFromUsers.some(
          alignedUser => alignedUser.id === user.value.uid
        )
    )

    const { objective } = toRefs(props)
    const { getAddUserIds, getRmUserIds } = useMention()
    watch(() => objective.value.alignedToUsers, (val, pre) => {
      const addUserIds = getAddUserIds(pre.map(item => item.id), val.map(item => item.id))
      const rmUserIds = getRmUserIds(pre.map(item => item.id), val.map(item => item.id))
      addAuth(addUserIds)
      removeAuth(rmUserIds)
    })

    function addAuth (addUserIds) {
      if (addUserIds.length === 0) {
        return
      }
      editObjectiveAuth(objective.value.id, addUserIds, 2).then(res => {
        console.log(res)
      })
    }

    function removeAuth (rmUserIds) {
      if (rmUserIds.length === 0) {
        return
      }
      removeObjectiveAuth(objective.value.id, rmUserIds, 2).then(res => {
        console.log(res)
      })
    }

    return {
      isToBeAligned
    }
  }
}
</script>

<style lang="less" scoped>
.objective-content {
  position: relative;

  &__icon {
    position: absolute;
    top: 1px;
    left: -27px;
    font-size: 19px;
  }

  &__alignment-up {
    position: absolute;
    left: -27px;
    top: -23px;
  }

  &__alignment-down {
    position: absolute;
    left: -27px;
    bottom: -23px;
  }
}

.to-be-aligned-dot {
  position: absolute;
  left: -52px;
  top: 7px;
}

.has-alignment-down::after {
  content: '';
  position: absolute;
  top: 22px;
  bottom: 0;
  left: -18px;
  border-left: 2px solid #b0bec5;
}

.financial-target-icon {
  width: 16px;
  cursor: pointer;
}
</style>
